import { prisma, TwilioChannel, ResourceType, ActionType } from "client";

// CREATE
export const createTwilioChannel = async (
  userId: string,
  data: TwilioChannel
) => {
  try {
        const twilioChannel = await prisma.twilioChannel.create({
      data: {
        ...data,
      },
    });
    return { twilioChannel };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllTwilioChannels = async (
  userId: string
): Promise<{
  twilioChannels?: TwilioChannel[];
  error?: any;
}> => {
  try {
        const twilioChannels = await prisma.twilioChannel.findMany();
    return { twilioChannels };
  } catch (error) {
    return { error };
  }
};

export const getTwilioChannelById = async (id: string) => {
  try {
    const twilioChannel = await prisma.twilioChannel.findUnique({
      where: { id },
    });
    return { twilioChannel };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateTwilioChannelById = async (
  userId: string,
  id: string,
  data: TwilioChannel
) => {
  try {
        const twilioChannel = await prisma.twilioChannel.update({
      where: { id },
      data: {
        ...data,
      },
    });
    return { twilioChannel };
  } catch (error) {
    return { error };
  }
};

// DELETE
export const deleteTwilioChannelById = async (userId: string, id: string) => {
  try {
        const twilioChannel = await prisma.twilioChannel.delete({
      where: { id },
    });
    return { twilioChannel };
  } catch (error) {
    return { error };
  }
};
